export const COLOR_BLACK = '#000000';
export const COLOR_WHITE = '#ffffff';
export const COLOR_PRIMARY = '#cdfd5f';
export const COLOR_TRANSPARENT = '#00000000';
export const COLOR_AQUA_100 = '#bde5e8';
export const COLOR_AQUA_200 = '#9bd7dd';
export const COLOR_AQUA_300 = '#7acad1';
export const COLOR_AQUA_400 = '#59bdc6';
export const COLOR_AQUA_500 = '#47979e';
export const COLOR_AQUA_600 = '#357677';
export const COLOR_AQUA_700 = '#244c4f';
export const COLOR_AQUA_800 = '#122628';
export const COLOR_BLUE_100 = '#9abde3';
export const COLOR_BLUE_200 = '#679cd6';
export const COLOR_BLUE_300 = '#4183cb';
export const COLOR_BLUE_400 = '#025aba';
export const COLOR_BLUE_500 = '#024895';
export const COLOR_BLUE_600 = '#013670';
export const COLOR_BLUE_700 = '#01244a';
export const COLOR_BLUE_800 = '#001225';
export const COLOR_GRAY_100 = '#f5f5f6';
export const COLOR_GRAY_200 = '#e8e8e8';
export const COLOR_GRAY_300 = '#e3e4e5';
export const COLOR_GRAY_400 = '#dadada';
export const COLOR_GRAY_500 = '#bfbfbf';
export const COLOR_GRAY_600 = '#808080';
export const COLOR_GRAY_700 = '#6c6c6c';
export const COLOR_GRAY_800 = '#3c3c3c';
export const COLOR_GRAY_900 = '#191919';
export const COLOR_GREEN_100 = '#e2f2bd';
export const COLOR_GREEN_200 = '#d3ec9b';
export const COLOR_GREEN_300 = '#c5e57a';
export const COLOR_GREEN_400 = '#b6df59';
export const COLOR_GREEN_500 = '#92b247';
export const COLOR_GREEN_600 = '#6d8635';
export const COLOR_GREEN_700 = '#495924';
export const COLOR_GREEN_800 = '#242d12';
export const COLOR_ORANGE_100 = '#f4d1b7';
export const COLOR_ORANGE_200 = '#eebb94';
export const COLOR_ORANGE_300 = '#e9a470';
export const COLOR_ORANGE_400 = '#e38d4c';
export const COLOR_ORANGE_500 = '#b6713d';
export const COLOR_ORANGE_600 = '#88552e';
export const COLOR_ORANGE_700 = '#5b381e';
export const COLOR_ORANGE_800 = '#2d1c0f';
export const COLOR_PINK_100 = '#f1c4e2';
export const COLOR_PINK_200 = '#e9a6d3';
export const COLOR_PINK_300 = '#e490c8';
export const COLOR_PINK_400 = '#db6bb6';
export const COLOR_PINK_500 = '#af5692';
export const COLOR_PINK_600 = '#83406d';
export const COLOR_PINK_700 = '#582b49';
export const COLOR_PINK_800 = '#2c1524';
export const COLOR_PURPLE_100 = '#ddc4eb';
export const COLOR_PURPLE_200 = '#cba6e2';
export const COLOR_PURPLE_300 = '#bf90da';
export const COLOR_PURPLE_400 = '#a96bce';
export const COLOR_PURPLE_500 = '#8756a5';
export const COLOR_PURPLE_600 = '#65407c';
export const COLOR_PURPLE_700 = '#442b52';
export const COLOR_PURPLE_800 = '#221529';
export const COLOR_RED_50 = '#fceeee';
export const COLOR_RED_100 = '#f6c5c0';
export const COLOR_RED_200 = '#f1a7a1';
export const COLOR_RED_300 = '#ee9189';
export const COLOR_RED_400 = '#e86d62';
export const COLOR_RED_500 = '#ba574e';
export const COLOR_RED_600 = '#8b413b';
export const COLOR_RED_700 = '#5d2c27';
export const COLOR_RED_800 = '#2e1614';
export const COLOR_TEAL_100 = '#b3ecdc';
export const COLOR_TEAL_200 = '#8de2ca';
export const COLOR_TEAL_300 = '#71dbbd';
export const COLOR_TEAL_400 = '#4eddb4';
export const COLOR_TEAL_500 = '#34a686';
export const COLOR_TEAL_600 = '#277c64';
export const COLOR_TEAL_700 = '#1a5343';
export const COLOR_TEAL_800 = '#0d2921';
export const COLOR_VIOLET_100 = '#cbc8f2';
export const COLOR_VIOLET_200 = '#b1acec';
export const COLOR_VIOLET_300 = '#9791e5';
export const COLOR_VIOLET_400 = '#7d75df';
export const COLOR_VIOLET_500 = '#645eb2';
export const COLOR_VIOLET_600 = '#4b4686';
export const COLOR_VIOLET_700 = '#322f59';
export const COLOR_VIOLET_800 = '#19172d';
export const COLOR_YELLOW_100 = '#f3eba1';
export const COLOR_YELLOW_200 = '#eee272';
export const COLOR_YELLOW_300 = '#e9da4f';
export const COLOR_YELLOW_400 = '#e2ce14';
export const COLOR_YELLOW_500 = '#b5a510';
export const COLOR_YELLOW_600 = '#887c0c';
export const COLOR_YELLOW_700 = '#5a5208';
export const COLOR_YELLOW_800 = '#2d2904';
export const COLOR_MANGO = '#f1a673';
export const OPACITY_100 = '0.1';
export const OPACITY_200 = '0.2';
export const OPACITY_300 = '0.3';
export const OPACITY_400 = '0.4';
export const OPACITY_500 = '0.5';
export const OPACITY_600 = '0.6';
export const OPACITY_700 = '0.7';
export const OPACITY_800 = '0.8';
export const OPACITY_900 = '0.9';
